import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import {
  IonIcon,
} from '@ionic/angular/standalone';

import { Observable } from 'rxjs';

import { addIcons } from 'ionicons';
import { alertCircleOutline, warningOutline } from 'ionicons/icons';

import { NetworkService } from '../../services/core/network.service';

@Component({
  selector: 'app-network-status-banner',
  //standalone: true,
  templateUrl: './network-status-banner.component.html',
  styleUrls: ['./network-status-banner.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
  ],
})
export class NetworkStatusBannerComponent {
  online$: Observable<boolean>;

  constructor(private networkService: NetworkService) {
    this.online$ = this.networkService.online$;
    addIcons({ alertCircleOutline, warningOutline , });
  }
}
